import React, { useState, useEffect } from 'react';
import InputGroup from './ui/InputGroup';
import ResultCard from './ui/ResultCard';
import ToggleGroup from './ui/ToggleGroup';

const ConversionCalculator = () => {
  const [weight, setWeight] = useState(1.5);
  const [unit, setUnit] = useState('oz');
  const [coffeeState, setCoffeeState] = useState('ground');
  
  const [tablespoons, setTablespoons] = useState(0);
  const [cups, setCups] = useState(0);
  const [grams, setGrams] = useState(0);

  useEffect(() => {
    const weightOz = unit === 'lbs' ? weight * 16 : weight;
    const wGrams = weightOz * 28.3495;
    setGrams(wGrams.toFixed(1));
    
    // Density Factors (approximate for commercial roast):
    // Ground coffee ≈ 5.0g per tbsp 
    // Whole bean ≈ 4.2g per tbsp (due to volume of whole beans)
    const gPerTbsp = coffeeState === 'ground' ? 5.0 : 4.2;
    const tbsp = wGrams / gPerTbsp;
    setTablespoons(tbsp.toFixed(1));
    
    // 16 tbsp = 1 dry cup
    setCups((tbsp / 16).toFixed(2));
    
  }, [weight, unit, coffeeState]);

  return (
    <div className="space-y-8 animate-fade-in">
      <div>
        <h2 className="text-2xl font-bold text-white mb-2">Volume Conversions</h2>
        <p className="text-slate-400">Convert dry weight to kitchen volume (Useful for clients without scales).</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-start">
        <div className="grid grid-cols-2 gap-3">
          <InputGroup
            label="Coffee Weight"
            id="weight"
            value={weight}
            onChange={(e) => setWeight(Number(e.target.value))}
            min="0.1"
            step="0.1"
          />
          <ToggleGroup
            label="Weight Unit"
            activeValue={unit}
            onChange={setUnit}
            options={[
              { label: 'Lbs', value: 'lbs' },
              { label: 'Oz', value: 'oz' },
            ]}
          />
        </div>
        <ToggleGroup
          label="Coffee State"
          activeValue={coffeeState}
          onChange={setCoffeeState}
          options={[
            { label: 'Whole Bean', value: 'whole' },
            { label: 'Ground', value: 'ground' },
          ]}
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-8">
        <ResultCard title="Tablespoons" value={tablespoons} unit="tbsp" highlight={true} />
        <ResultCard title="Dry Cup Measure" value={cups} unit="cups" />
        <ResultCard title="Grams" value={grams} unit="g" />
      </div>
    </div>
  );
};

export default ConversionCalculator;